import { useCreate } from '../../../api/react-query';

export function useCreateByConfigId() {
  const {
    mutateAsync: createByConfigId,
    isLoading: isCreating,
    error,
  } = useCreate({
    url: 'config/type',
    apiVersion: 'v1',
  });

  return {
    createByConfigId,
    isCreating,
    error,
  };
}
